<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 48 48"><title>{{ title }}</title>
    <g>
      <path :fill="fill"
            d="M30.382,47.177l3.235-2.354L18.473,24L33.618,3.177l-3.235-2.354l-16,22c-0.51,0.702-0.51,1.651,0,2.354 L30.382,47.177z"></path>
    </g>
  </svg>
</template>

<script>
export default {
  name: "Prev",
  props: {
    title: {
      type: String,
      default: "Précédent"
    },
    size: {
      type: Number,
      default: 18,
    },
    fill: {
      type: String,
      default: 'currentColor',
    },
  },
}
</script>

<style scoped lang="scss">

</style>

